import { render, staticRenderFns } from "./MoleculeEditionAcademyLegalsEmailClause.vue?vue&type=template&id=70bb9980&"
import script from "./MoleculeEditionAcademyLegalsEmailClause.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyLegalsEmailClause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports